/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-carbon'
], function(
	React,
	ReactDOM,
	PropTypes,
	UI_Toolkit,
	CARBON
) {
	const { Component } = React;
	const { Container, FlexLayout, FlexItem, SVGIcon, Multilinetruncatedtext, TruncatedText } = UI_Toolkit;
	const { ClickableTile } = CARBON;
	class VisualizationContentContainer extends Component {

		componentDidMount() {
			const { handlers  } = this.props;
			handlers.componentDidMountCallback(this.props.containerClass, this.props.itemClass);
		}

		componentWillUnmount () {
			const { handlers  } = this.props;
			handlers.componentWillUnmountCallback(this.props.containerClass, this.props.itemClass);
		}

		render () {
			const { containerClass, items } = this.props;
			const contentItems = [];
			items.forEach((item) => {
				contentItems.push(this.renderVisualizationItem(item));
			});

			return (
				<Container className={containerClass}>
					<FlexLayout
						fullHeight
						direction="column"
						justifyContent='flex-start'
					>
						<FlexItem>
							<FlexLayout
								fullHeight
								direction="row"
								wrap='wrap'
							>
								{contentItems}
							</FlexLayout>
						</FlexItem>
					</FlexLayout>
				</Container>
			);
		}

		renderVisualizationItem (item) {
			const SEPARATOR = ' ';
			const containSeparator = item.label && item.label.includes(SEPARATOR);
			return (
				<FlexItem
					role={'group'} className='prop-item'
					data-name={item.name}
					walkme-data-id={item.name}
				>
					<ClickableTile
						className="vis-type-tile"
					>
						<FlexLayout
							fullHeight
							direction="column"
							alignItems='center'
							justifyContent='center'
							tabIndex={0}
							className='prop-icon'
							role={'button'}
							aria-label={item.label}
						>
							<FlexItem>
								<SVGIcon
									iconId={item.icon}
									height={24}
									width={24}
									className='svgIcon'
								>
								</SVGIcon>
							</FlexItem>
							<FlexItem>
								<div className='prop-icon-label-container'>
									{containSeparator ?
										(
											<Multilinetruncatedtext
												className='prop-icon-label'
												value={item.label}
												numLines={2}
											/>
										) : (
											<TruncatedText
												className='prop-icon-label'
												value={item.label}
											/>
										)
									}
								</div>
							</FlexItem>
						</FlexLayout>
					</ClickableTile>
				</FlexItem>
			);
		}
	}

	VisualizationContentContainer.propTypes = {
		items: PropTypes.array.isRequired,
		containerClass: PropTypes.string.isRequired,
		itemClass: PropTypes.string.isRequired,
		handlers: PropTypes.shape({
			componentDidMountCallback: PropTypes.func.isRequired,
			componentWillUnmountCallback: PropTypes.func.isRequired
		}).isRequired
	};

	return VisualizationContentContainer;
});
